<template>
  <div>
    <div v-for="(item, itemIndex) in navData" :key="itemIndex">
      <transition name="slide">
        <div v-if="item.groups.length && selectedItemIndex === itemIndex" class="absolute z-40 left-0 top-0 w-full bg-white shadow">
          <div class="container mx-auto flex justify-center">
            <ul class="flex mt-8 mb-4">
              <li v-for="group in item.groups" class="font-head font-semibold text-base text-primary leading-none flex flex-col m-0">
                <div v-for="area in group">
                  <div class="mb-2 mx-4">
                    <a class="block mb-4 uppercase" :href="area.url" :title="area.title" v-text="area.title"></a>
                    <ul v-if="area.children.length" class="border-l border-primary pl-3 mb-8">
                      <li v-for="section in area.children" class="mb-3 last:mb-0 font-head text-sm text-secondary">
                        <a :href="section.url" :title="section.title" v-text="section.title"></a>
                      </li>
                    </ul>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div v-else-if="item.children.length && selectedItemIndex === itemIndex" class="absolute z-40 left-0 top-0 w-full bg-white shadow">
          <div class="container mx-auto flex justify-center">
            <ul class="flex mt-8 mb-4">
              <li v-for="child in item.children" class="font-head font-semibold text-base text-primary leading-none flex flex-col m-0">
                <div class="mb-2 mx-4">
                    <a class="block mb-4 uppercase" :href="child.url" :title="child.title" v-text="child.title"></a>
                    <ul v-if="child.children.length" class="border-l border-primary pl-3 mb-8">
                      <li v-for="grandchild in child.children" class="mb-3 last:mb-0 font-head text-sm text-secondary">
                        <a :href="grandchild.url" :title="grandchild.title" v-text="grandchild.title"></a>
                      </li>
                    </ul>
                  </div>
              </li>
            </ul>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
import {mapState} from 'vuex'

export default {
  computed: {
    ...mapState('navigation', {
      navData: 'navData',
      selectedItemIndex: 'selectedItemIndex'
    })
  }
}
</script>
<style lang="scss" scoped>
.slide-enter-active, .slide-leave-active {
  transition: all .5s ease;
}

.slide-enter, .slide-leave-to {
  transform: translateY(-100%);
  opacity: 0;
}
</style>
